var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPattern(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1440,
    height: 250,
    viewBox: "0 0 1440 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 0.198,
    x2: 0.5,
    y2: 1.264,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.611,
    stopColor: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4d4d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1.051,
    y1: 0.535,
    x2: 0.563,
    y2: 0.476,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101624"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1.051,
    y1: 0.535,
    x2: 0.563,
    y2: 0.476,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101624",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.924,
    y1: 0.549,
    x2: 0.612,
    y2: 0.434,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c7c7c7",
    stopOpacity: 0.149
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101624",
    stopOpacity: 0.388
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1.051,
    y1: 0.625,
    x2: 0.325,
    y2: 0.593,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c7c7c7",
    stopOpacity: 0.329
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#646464"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.989,
    y1: 0.404,
    x2: 0.151,
    y2: 0.303,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c7c7c7",
    stopOpacity: 0.071
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#646464"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1.04,
    y1: 0.5,
    x2: -0.084,
    y2: -0.038,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c7c7c7",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#646464"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.971,
    y1: 0.104,
    x2: 0.24,
    y2: 0.441,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#101624",
    stopOpacity: 0.051
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101624",
    stopOpacity: 0.251
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 0.979,
    y1: 0.476,
    x2: 0.749,
    y2: 0.378,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.941
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#646464",
    stopOpacity: 0.361
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 0.981,
    y1: 0.135,
    x2: 0.519,
    y2: 0.443,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101624",
    stopOpacity: 0.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-new"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 250
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "new",
    clipPath: "url(#clip-new)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 250,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7107",
    "data-name": "Group 7107",
    transform: "translate(-5101 16397)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1550",
    "data-name": "Rectangle 1550",
    width: 1506,
    height: 374,
    transform: "translate(5089 -16397)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "cover-copy-3",
    transform: "translate(6623.376 -15615.492) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(0 34)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7113",
    "data-name": "Group 7113",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    width: 458.745,
    height: 96.403,
    transform: "translate(214.505 213.728) rotate(45)",
    opacity: 0.15,
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    width: 459.696,
    height: 93.5,
    transform: "translate(66.114 232.15) rotate(45)",
    opacity: 0.15,
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    width: 909.494,
    height: 147.316,
    transform: "translate(486.313 0) rotate(45)",
    opacity: 0.07,
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    width: 574.093,
    height: 43.49,
    transform: "translate(252.672 169.141) rotate(45)",
    opacity: 0.15,
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2-2",
    "data-name": "Rectangle-Copy",
    width: 458.743,
    height: 62.346,
    transform: "translate(1354.788 285.014) rotate(135)",
    opacity: 0.15,
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3-2",
    "data-name": "Rectangle-Copy-3",
    width: 621.884,
    height: 93.499,
    transform: "translate(1581.142 286.07) rotate(135)",
    opacity: 0.15,
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    width: 310.294,
    height: 24.967,
    transform: "translate(1507.758 434.084) rotate(135)",
    opacity: 0.15,
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-5",
    width: 508.57,
    height: 220.551,
    transform: "translate(589.805 293.786) rotate(135)",
    opacity: 0.15,
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-5-2",
    "data-name": "Rectangle-Copy-5",
    width: 724.854,
    height: 171.552,
    transform: "translate(1092.828 39.025) rotate(45)",
    opacity: 0.15,
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4-2",
    "data-name": "Rectangle-Copy-4",
    width: 642.907,
    height: 210.801,
    transform: "translate(1189.821 260.437) rotate(135)",
    opacity: 0.15,
    fill: "url(#linear-gradient-11)"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern);
export default __webpack_public_path__ + "static/media/pattern.26f3717e7f23ea979800d1a32df668c0.svg";
export { ForwardRef as ReactComponent };